import { RichText } from "@punks/core"
import React from "react"
import { StoreDocumentV2 } from "../../../../api/backend/backend-api"
import { TwRichTextField } from "../../../../root/punks/core/fields/RichTextField"
import CustomSelect from "../../../../ui/atoms/CustomSelect"
import { CustomCol, CustomRow } from "../../../../ui/spacings"
import { toTitleCase } from "../../../../utils/strings"
import EventCalendar from "../../../calendar/components/EventCalendar"
import { useStores } from "../../hooks"

export interface StoreVisitReservationProps {
  title?: RichText
  message?: RichText
  selectedCalendarId?: string
}

const StoreVisitReservation = ({
  title,
  message,
  selectedCalendarId,
}: StoreVisitReservationProps) => {
  const { data } = useStores({
    includeHidden: true,
  })
  const storesWithCalendar = data?.filter((x) => x.storeVisitCalendar) ?? []

  const [store, setStore] = React.useState<StoreDocumentV2>()
  const [calendarId, setCalendarId] = React.useState(selectedCalendarId)

  React.useEffect(() => {
    if (!calendarId && storesWithCalendar.length > 0) {
      setStore(storesWithCalendar[0] as StoreDocumentV2)
      setCalendarId(
        (storesWithCalendar[0] as StoreDocumentV2).storeVisitCalendar?.url
      )
    }
  }, [storesWithCalendar])

  return (
    <>
      <CustomRow spacing justify="center">
        <CustomCol xs={12} sm={8}>
          <div className="px-4 sm:px-2">
            <TwRichTextField value={title} variant="h4" />
            <TwRichTextField value={message} variant="body1" />
            {!selectedCalendarId && (
              <div className="mt-6">
                <CustomSelect
                  values={storesWithCalendar.map((x) => ({
                    id: x.id,
                    label: `${x.name.toUpperCase()}, ${toTitleCase(
                      x.address.street
                    )}`,
                  }))}
                  value={store?.id ?? ""}
                  onChange={(id) => {
                    const store = storesWithCalendar.find((x) => x.id === id)
                    setStore(store)
                    setCalendarId(store?.storeVisitCalendar?.url)
                  }}
                  size="medium"
                  className="w-full sm:w-auto"
                />
              </div>
            )}
            {/* {store && (
              <div>
                <Typography variant="subtitle2">{store.name}</Typography>
                <Typography variant="subtitle2" weight="normal">
                  {store.address.street}
                </Typography>
                <div className="mt-4">
                  <Typography variant="subtitle2" weight="normal">
                    {store.address.cap} - {store.address.city}
                    {store.address.province !== store.address.city
                      ? ` (${store.address.province})`
                      : ""}
                  </Typography>
                </div>
              </div>
            )} */}
          </div>
        </CustomCol>
        {/* <CustomCol xs={12} sm={6} className="mt-6 sm:mt-0">
          {store && <StoreMap store={store} />}
        </CustomCol> */}
      </CustomRow>
      <div className="mb-4">
        {calendarId && (
          <div>
            <EventCalendar calendarAlias={calendarId} />
          </div>
        )}
      </div>
    </>
  )
}

export default StoreVisitReservation
